var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isOpen)?_c('button',{staticClass:"fixed inset-0 h-full w-full cursor-default focus:outline-none z-10",attrs:{"tabindex":"-1"},on:{"click":_vm.close}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }